import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';
import { LegalEntityFormValues } from 'features/new-actor/types/legalEntityFormValues';
import { NaturalPersonFormValues } from 'features/new-actor/types/optim/naturalPersonFormValues';
import { PossibleAnswer } from '../../types/interfaces';

// =============================================================================
// FIELD NAMES
// =============================================================================

export const BorrowerInsuredFormFieldNames = {
  SurveyForm: 'surveyForm',
  IsFPE: 'isFPE',
  Job: 'job',
  ProspectType: 'prospectType',
  BorrowerId: 'borrowerId'
} as const;

export type BorrowerInsuredFormFieldNames =
  (typeof BorrowerInsuredFormFieldNames)[keyof typeof BorrowerInsuredFormFieldNames];

// =============================================================================
// FORM VALUES TYPES
// =============================================================================

export interface BorrowerBaseFormValues {
  [BorrowerInsuredFormFieldNames.SurveyForm]?: Record<string, PossibleAnswer>;
  [BorrowerInsuredFormFieldNames.Job]: string;
  [BorrowerInsuredFormFieldNames.ProspectType]: string;
  [BorrowerInsuredFormFieldNames.BorrowerId]?: string;
}

export interface BorrowerNaturalFormValues
  extends NaturalPersonFormValues,
    BorrowerBaseFormValues {}

export interface BorrowerLegalFormValues
  extends LegalEntityFormValues,
    BorrowerBaseFormValues {}

export interface BorrowerInsuredFormValues
  extends BorrowerNaturalFormValues,
    BorrowerLegalFormValues {}

// =============================================================================
// BASE VALIDATION RULES (shared between Natural & Legal)
// =============================================================================

export const borrowerBaseValidationRules: ValidationRules<
  keyof BorrowerBaseFormValues
> = {
  [BorrowerInsuredFormFieldNames.SurveyForm]: Yup.object()
    .required('Ce champ est requis')
    .test('is-valid-survey-form', 'Format de formulaire invalide', (value) => {
      if (!value || typeof value !== 'object') return false;
      return Object.values(value).every((val) => Array.isArray(val));
    }),

  [BorrowerInsuredFormFieldNames.Job]: Yup.string().required(
    'Ce champ est requis'
  ),

  [BorrowerInsuredFormFieldNames.ProspectType]: Yup.string().required(
    'Ce champ est requis'
  ),

  [BorrowerInsuredFormFieldNames.BorrowerId]: Yup.string()
};
